import { colors, shades } from 'utils';
import defaults from './defaults';
const { primary, sec } = colors;
const { neutrals, teals } = shades;
const { fontFamily, fontSize, fontWeight, lineHeight, transition } = defaults;

const theme = {
  primary,
  sec,
  neutrals,
  teals,
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  transition
};

export default theme;



// WEBPACK FOOTER //
// ./src/utils/theme.js